import { useDispatch, useSelector } from "react-redux";
import { IDLE_MSG } from "../../constants.js";
import { formatMessageDataV2 } from "../utils/formatData.js";
import {
    incrementPosition,
    concatMessage,
    setIsEnd,
} from "../features/messagesSlice.js";

export default function useRefreshData() {
    const dispatch = useDispatch();

    const expiredScheduler = useSelector(
        (state) => state.messages.expiredScheduler
    );

    const messages = useSelector((state) => state.messages.messages);
    const deviceId = useSelector((state) => state.session.deviceId);
    const position = useSelector((state) => state.messages.position);

    const expiredAt = useSelector((state) => state.messages.expiredAt);
    const handleExpirySchedule = () => {
        const timeNow = new Date();
        const isExpired = expiredAt < timeNow;

        // End chat after 6 minutes
        if (isExpired) {
            dispatch(setIsEnd(true));
            clearInterval(expiredScheduler);
        } else {
            const isHalf =
                timeNow >= new Date(expiredAt).getTime() - 2 * 60000;
            if (isHalf) {
                const lastIdleMessage = messages
                    .slice()
                    .reverse()
                    .find((msg) => msg.content === IDLE_MSG);
                if (
                    !lastIdleMessage ||
                    new Date(lastIdleMessage?.created_at) <=
                        new Date(timeNow - 2 * 60000)
                ) {
                    const message = formatMessageDataV2(
                        deviceId,
                        "bot",
                        IDLE_MSG,
                        position,
                        true
                    );
                    dispatch(concatMessage(message));
                    dispatch(incrementPosition());
                }
            }
        }
    };

    return { handleExpirySchedule };
}
